<template>
	<div class="round-interstitial">
		<div class="content-wrapper">
			<HeadingSVG :imgName="`round-${round.order}`" :altText="`Round ${round.order}`" />
			<Host />
			<div class="slider">
				<div class="intro" v-for="slide in currentSlideArray" :key="slide.id">
					<div class="wysiwyg-content" v-html="slide.content" />
				</div>
			</div>
				<div class="btn-wrapper">
					<transition name="fade">
						<Button class="view-previous-btn" :action="previous" v-if="currentIndex > 0" />
					</transition>
					<transition name="fade">
						<Button class="view-next-btn" :action="next" v-if="!isLastSlide" />
					</transition>
				</div>
				<MarqueeButton :action="advance" v-show="isLastSlide">{{ round.button_text }}</MarqueeButton>
			</div>
		</div>
</template>

<script>
import HeadingSVG from '@/components/base/HeadingSVG';
import Host from '@/components/base/Host';
import MarqueeButton from '@/components/base/MarqueeButton';
import carouselMixins from "@/mixins/carousel-slides";

export default {
	name: 'RoundInterstitial',
	mixins: [carouselMixins],
	components: {
		HeadingSVG,
		Host,
		MarqueeButton,
	},
	computed: {
		round() {
			return this.$store.getters["game/rounds/active"];
		},
		slides() {
			return Object.values(this.round.introduction);
		},
	},
	methods: {
		advance() {
			this.$router.push('/game/shop');
			this.$store.dispatch("sound/fx/play", { id: "button_generic" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.round-interstitial {
		@include swirl-background;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100%;
		min-height: 100vh;
		color: white;
		text-align: center;
		overflow: scroll;

		@include desktop {
			align-items: center;
			justify-content: center;
		}
	}

	.content-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		max-width: 500px;
		padding: 0 20px $page-bottom-spacing;


		@include tablet {
			max-width: unset;
			width: 80%;
			margin-bottom: unset;
		}

		@include desktop {
			max-width: 500px;
			transform: translateX(50%);
			padding: 0;
		}

		@include desktop-lg { max-width: 600px; }
	}

	.host-component {
		margin: 20px 0;

		@include desktop {
			position: absolute;
			right: 100%;
			margin-right: 50px; // give room for arrows
			width: 100%;
			min-height: 300px;
			max-height: 450px;
		}

		@include desktop-lg { max-height: 600px; }
	}

	.heading {
		margin: 40px 0 0;

		@include desktop {
			position: relative;
			margin: 0;
		}
	}

	.intro {
		margin: 0 auto 20px;
		width: 70%;

		@include tablet { width: 100%; }
		@include desktop { margin: 40px 0; }
	}

	.marquee-btn { margin: 0; }

	.slider { position: relative; }

	.btn-wrapper {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
		pointer-events: none;

		@include mobile {
			top: unset;
			height: 100px;
		}
	}

	.view-previous-btn,
	.view-next-btn {
		position: absolute;
		margin: auto 0;
		top: 0;
		bottom: 0;
		pointer-events: all;
		z-index: $z-top;
	}

	@include mobile {
		.view-next-btn { right: 0; }
		.view-previous-btn { left: 0; }
	}

	@include tablet {
		.view-next-btn { right: 0; }
		.view-previous-btn { left: 0; }
	}

	@include desktop {
		.view-next-btn { left: 100%; right: unset; }
		.view-previous-btn { right: 100%; left: unset; }
	}
</style>
